import { Icons } from "widgets";

import cardItems from "../assets/icons/cards/items_100x80.svg";
import cardListing from "../assets/icons/cards/listing_100x80.svg";
import cardSamples from "../assets/icons/cards/samples_100x80.svg";
import cardtips from "../assets/icons/cards/tips_100x80.svg";
import p16sSmall from "../assets/icons/mini/16s_20x20.svg";
import blastSmall from "../assets/icons/mini/blast_20x20.svg";
import chartSmall from "../assets/icons/mini/chart_20x20.svg";
import registrationSmall from "../assets/icons/mini/check_registration_20x20.svg";
import configSmall from "../assets/icons/mini/config_20x20.svg";
import dataviewerSmall from "../assets/icons/mini/data_viewer_20x20.svg";
import defaultSmall from "../assets/icons/mini/default_playbook_20x20.svg";
import detectionSmall from "../assets/icons/mini/detection_20x20.svg";
import experimentSmall from "../assets/icons/mini/experiment_20x20.svg";
import genomeviewerSmall from "../assets/icons/mini/genome_viewer_20x20.svg";
import plantsSmall from "../assets/icons/mini/plants_20x20.svg";
import plateSmall from "../assets/icons/mini/plate_20x20.svg";
import reportSmall from "../assets/icons/mini/report_20x20.svg";
import sample1Small from "../assets/icons/mini/sample1_20x20.svg";
import sample2Small from "../assets/icons/mini/sample2_20x20.svg";
import scanSmall from "../assets/icons/mini/scan_20x20.svg";
import tlaSmall from "../assets/icons/mini/tla_20x20.svg";
import vegetablesSmall from "../assets/icons/mini/vegetables_20x20.svg";
import virusSmall from "../assets/icons/mini/virus_20x20.svg";
import analystLarge from "../assets/icons/modules/analyst_140x80.svg";
import arrayLarge from "../assets/icons/modules/array_140x80.svg";
import explorerLarge from "../assets/icons/modules/explorer_140x80.svg";
import processorLarge from "../assets/icons/modules/processor_140x80.svg";
import trackerLarge from "../assets/icons/modules/tracker_140x80.svg";
import FileIconCode from "../assets/icons/tiles/file/icon_code.svg?react";
import FileIconExcel from "../assets/icons/tiles/file/icon_excel.svg?react";
import FileIconImage from "../assets/icons/tiles/file/icon_image.svg?react";
import FileIconPdf from "../assets/icons/tiles/file/icon_pdf.svg?react";
import FileIconPowerpoint from "../assets/icons/tiles/file/icon_powerpoint.svg?react";
import FileIconText from "../assets/icons/tiles/file/icon_text.svg?react";
import FileIconVideo from "../assets/icons/tiles/file/icon_video.svg?react";
import FileIconWord from "../assets/icons/tiles/file/icon_word.svg?react";
import CatFlower01 from "../assets/img/categories/aarn-giri-3tYZjGSBwbk-unsplash.webp";
import CatClock01 from "../assets/img/categories/age-barros-rBPOfVqROzY-unsplash.webp";
import CatDNA01 from "../assets/img/categories/alexander-popov-eXoXJrOGqG4-unsplash.webp";
import CatVegetable03 from "../assets/img/categories/atik-sulianami-xwiO6w6XEiM-unsplash.webp";
import CatEntity01 from "../assets/img/categories/cdc-2-Hv-Rg4asA-unsplash.webp";
import CatInfrared01 from "../assets/img/categories/cdc-4U6qzwNu-Ns-unsplash.webp";
import CatEntity02 from "../assets/img/categories/cdc-9zufjjagejk-unsplash.webp";
import CatEntity03 from "../assets/img/categories/cdc-aQOe0Ri267U-unsplash.webp";
import CatEntity06 from "../assets/img/categories/cdc-auxSQi4Achk-unsplash.webp";
import CatEntity04 from "../assets/img/categories/cdc-L0jLHqF7Q94-unsplash.webp";
import CatEntity05 from "../assets/img/categories/cdc-ljiPMfg-0m0-unsplash.webp";
import CatInfrared02 from "../assets/img/categories/cdc-p6slMrGDQSo-unsplash.webp";
import CatLab01 from "../assets/img/categories/cdc-y--8fqaK1kY-unsplash.webp";
import CatFocus02 from "../assets/img/categories/colin-lloyd-suj3od1uMv8-unsplash.webp";
import CatFlower02 from "../assets/img/categories/erol-ahmed-aIYFR0vbADk-unsplash.webp";
import CatAbstract01 from "../assets/img/categories/fakurian-design-58Z17lnVS4U-unsplash.webp";
import CatAbstract02 from "../assets/img/categories/frida-bredesen-c_cPNXlovvY-unsplash.webp";
import CatFocus01 from "../assets/img/categories/joshua-coleman-E_2lA5a9i6I-unsplash.webp";
import CatAbstract03 from "../assets/img/categories/karan-karnik-w7WVYjY8c5w-unsplash.webp";
import CatAbstract06 from "../assets/img/categories/krystal-ng-PrQqQVPzmlw-unsplash.webp";
import CatLab02 from "../assets/img/categories/louis-reed-pwcKF7L4-no-unsplash.webp";
import CatNumber01 from "../assets/img/categories/mae-mu-VoQ4kqDSFxg-unsplash.webp";
import CatAbstract05 from "../assets/img/categories/manuel-CANL3bzp6wU-unsplash.webp";
import CatVegetable02 from "../assets/img/categories/maros-misove-HGNtPpNQBcI-unsplash.webp";
import CatAbstract10 from "../assets/img/categories/mike-hindle-7cc4Zi_L3x0-unsplash.webp";
import CatEntity08 from "../assets/img/categories/national-cancer-institute-dMZC6hdobnk-unsplash.webp";
import CatEntity07 from "../assets/img/categories/national-cancer-institute-LnvCEXQwC-o-unsplash.webp";
import CatLab03 from "../assets/img/categories/national-cancer-institute-zQkoVCTyaHI-unsplash.webp";
import CatNumber02 from "../assets/img/categories/pascal-meier-VXOchK7U80E-unsplash.webp";
import CatDefault from "../assets/img/categories/ryan-quintal-US9Tc9pKNBU-unsplash.webp";
import CatAbstract04 from "../assets/img/categories/ryan-tpAyLp9Ro50-unsplash.webp";
import CatAbstract07 from "../assets/img/categories/sangga-rima-roman-selia-p-EM8Nbz3fg-unsplash.webp";
import CatVegetable01 from "../assets/img/categories/sebastian-klein-pAlkR1B0Fck-unsplash.webp";
import CatAbstract08 from "../assets/img/categories/susan-wilkinson-Se9c6-S8eDs-unsplash.webp";
import CatLab04 from "../assets/img/categories/testalize-me-0jE8ynV4mis-unsplash.webp";
import CatAbstract09 from "../assets/img/categories/zach-camp-V32AqCPqhDo-unsplash.webp";

export type ModulesIcons = (typeof ModulesIcons)[keyof typeof ModulesIcons];
export type SelectorIcons = (typeof SelectorIcons)[keyof typeof SelectorIcons];
export type CardIcons = (typeof CardIcons)[keyof typeof CardIcons];
export type PlaybookCategoriesIcons = (typeof PlaybookCategoriesIcons)[keyof typeof PlaybookCategoriesIcons];

export interface SelectorIcon {
  large: string;
  small?: string;
  medium?: string;
  id?: string;
}

export type PlaybookCategoryIcon = SelectorIcon;

export const ModulesIcons: Record<string, SelectorIcon> = {
  // Modules
  ANALYST: {
    large: analystLarge,
    medium: Icons.Tiles.Analyst,
  },
  ARRAY: {
    large: arrayLarge,
    medium: Icons.Tiles.Array,
  },
  EXPLORER: {
    large: explorerLarge,
  },
  PROCESSOR: {
    large: processorLarge,
    medium: Icons.Tiles.Processor,
  },
  TRACKER: {
    large: trackerLarge,
  },
  // Restricted
  BLAST: {
    large: Icons.Large.Blast,
    small: blastSmall,
  },
  DATA_VIEWER: {
    large: Icons.Large.AnalyticalDataViewer,
    medium: Icons.Tiles.AnalyticalDataViewer,
    small: dataviewerSmall,
  },
  GENOME_VIEWER: {
    large: Icons.Large.GenomeViewer,
    medium: Icons.Tiles.GenomeViewer,
    small: genomeviewerSmall,
  },
  VIEWER: {
    large: Icons.Large.GenomeViewer,
    small: genomeviewerSmall,
  },
  PLAYBOOK_EDITOR: {
    large: Icons.Large.PlaybookConfiguration,
    small: configSmall,
  },
  SAMPLE_REGISTRATION: {
    large: Icons.Large.Registration,
    small: registrationSmall,
  },
  DEFAULT: {
    large: Icons.Large.Playbook,
    small: defaultSmall,
  },
  ENTITY: {
    large: "",
    medium: Icons.Tiles.Entity,
  },
  WORKFLOW: {
    large: Icons.Large.Workflow,
    medium: Icons.Tiles.Workflow,
  },
};

export const SelectorIcons: Record<string, SelectorIcon> = {
  CHART: {
    large: Icons.Large.Chart,
    small: chartSmall,
    id: "chart",
  },
  CHECK: {
    large: Icons.Large.Check,
    small: registrationSmall,
    id: "check",
  },
  CONFIG: {
    large: Icons.Large.Configuration,
    small: configSmall,
    id: "config",
  },
  DETECTION: {
    large: Icons.Large.Detection,
    small: detectionSmall,
    id: "detection",
  },
  EXPERIMENT: {
    large: Icons.Large.Experiment,
    small: experimentSmall,
    id: "experiment",
  },
  PLANTS: {
    large: Icons.Large.Plants,
    small: plantsSmall,
    id: "plants",
  },
  PLATE: {
    large: Icons.Large.Plate,
    small: plateSmall,
    id: "plate",
  },
  REPORT: {
    large: Icons.Large.Report,
    small: reportSmall,
    id: "report",
  },
  SAMPLE_REGISTRATION: {
    large: Icons.Large.Registration,
    small: registrationSmall,
    id: "registration",
  },
  SAMPLE1: {
    large: Icons.Large.Sample1,
    small: sample1Small,
    id: "sample1",
  },
  SAMPLE2: {
    large: Icons.Large.Sample2,
    small: sample2Small,
    id: "sample2",
  },
  SCAN: {
    large: Icons.Large.Scan,
    small: scanSmall,
    id: "scan",
  },
  VEGETABLES: {
    large: Icons.Large.Vegetables,
    small: vegetablesSmall,
    id: "vegetables",
  },
  VIRUS: {
    large: Icons.Large.Virus,
    small: virusSmall,
    id: "virus",
  },
  P16S: {
    large: Icons.Large.SixteenS,
    small: p16sSmall,
    id: "p16s",
  },
  TLA: {
    large: Icons.Large.TLA,
    small: tlaSmall,
    id: "tla",
  },
};

export const PlaybookCategoriesIcons: Record<string, SelectorIcon> = {
  DEFAULT: { large: CatDefault, id: "default" },
  LAB01: { large: CatLab01, id: "lab01" },
  LAB02: { large: CatLab02, id: "lab02" },
  LAB03: { large: CatLab03, id: "lab03" },
  LAB04: { large: CatLab04, id: "lab04" },
  ENTITY01: { large: CatEntity01, id: "entity01" },
  ENTITY02: { large: CatEntity02, id: "entity02" },
  ENTITY03: { large: CatEntity03, id: "entity03" },
  ENTITY04: { large: CatEntity04, id: "entity04" },
  ENTITY05: { large: CatEntity05, id: "entity05" },
  ENTITY06: { large: CatEntity06, id: "entity06" },
  ENTITY07: { large: CatEntity07, id: "entity07" },
  ENTITY08: { large: CatEntity08, id: "entity08" },
  DNA01: { large: CatDNA01, id: "dna01" },
  INFRARED01: { large: CatInfrared01, id: "infrared01" },
  INFRARED02: { large: CatInfrared02, id: "infrared02" },
  FLOWER01: { large: CatFlower01, id: "flower01" },
  FLOWER02: { large: CatFlower02, id: "flower02" },
  VEGETABLE01: { large: CatVegetable01, id: "vegetable01" },
  VEGETABLE02: { large: CatVegetable02, id: "vegetable02" },
  VEGETABLE03: { large: CatVegetable03, id: "vegetable03" },
  ABSTRACT01: { large: CatAbstract01, id: "abstract01" },
  ABSTRACT02: { large: CatAbstract02, id: "abstract02" },
  ABSTRACT03: { large: CatAbstract03, id: "abstract03" },
  ABSTRACT04: { large: CatAbstract04, id: "abstract04" },
  ABSTRACT05: { large: CatAbstract05, id: "abstract05" },
  ABSTRACT06: { large: CatAbstract06, id: "abstract06" },
  ABSTRACT07: { large: CatAbstract07, id: "abstract07" },
  ABSTRACT08: { large: CatAbstract08, id: "abstract08" },
  ABSTRACT09: { large: CatAbstract09, id: "abstract09" },
  ABSTRACT10: { large: CatAbstract10, id: "abstract10" },
  NUMBER01: { large: CatNumber01, id: "number01" },
  NUMBER02: { large: CatNumber02, id: "number02" },
  CLOCK01: { large: CatClock01, id: "clock01" },
  FOCUS01: { large: CatFocus01, id: "focus01" },
  FOCUS02: { large: CatFocus02, id: "focus02" },
};

export const CardIcons = {
  ITEMS: cardItems,
  LISTING: cardListing,
  SAMPLES: cardSamples,
  TIPS: cardtips,
};

/**
 * All file type icons
 * @see FileDefinition
 */
export const FileTypeIcons: Record<string, any> = {
  htm: FileIconCode,
  html: FileIconCode,
  xhtml: FileIconCode,
  xml: FileIconCode,
  xls: FileIconExcel,
  xlsx: FileIconExcel,
  jpeg: FileIconImage,
  jpg: FileIconImage,
  tiff: FileIconImage,
  tif: FileIconImage,
  png: FileIconImage,
  apng: FileIconImage,
  gif: FileIconImage,
  bmp: FileIconImage,
  webp: FileIconImage,
  heif: FileIconImage,
  heic: FileIconImage,
  avif: FileIconImage,
  pdf: FileIconPdf,
  ppt: FileIconPowerpoint,
  pptx: FileIconPowerpoint,
  txt: FileIconText,
  rtf: FileIconText,
  rtxt: FileIconText,
  csv: FileIconText,
  tsv: FileIconText,
  log: FileIconText,
  mpg: FileIconVideo,
  mpeg: FileIconVideo,
  avi: FileIconVideo,
  mov: FileIconVideo,
  webm: FileIconVideo,
  mp4: FileIconVideo,
  mp5: FileIconVideo,
  mkv: FileIconVideo,
  heiv: FileIconVideo,
  av1: FileIconVideo,
  doc: FileIconWord,
  docx: FileIconWord,
};
